import { SystemObject } from './enums/system-object';
import { Language } from './enums/language';

export class ValidationDto {
    objectType: SystemObject;
    property: string;
    value: string;
    lang: Language;
}